import { fly } from 'svelte/transition';

export const flyDrawer = (element: Element) => {
    const mediaQuery = '(min-width: 1280px)';
    if (window.matchMedia(mediaQuery).matches) {
        return fly(element, {
            x: '44vw',
            duration: 300,
            opacity: 1,
        });
    }

    return fly(element, {
        y: '100vh',
        duration: 300,
        opacity: 1,
    });
};
